import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    GetAllCollectionPoints,
    getAllOperationEntitiesForDropDown,
    getGroupByCollectionCatagoryID,
    getOperationentityCollectionCatagoryFilterData,
    AddOperationentityCollectionCatagory,
    getAvialableProducts,
    getUnsusedProducts,
    EditOperationentityCollectionCatagory,
    getCollectionCategoryByProductID,
    getProducts,
    getCollectionType,
    checkDefaultColletionTypeAvailability,
    getCollectionTypeForEditScreen
};

async function getOperationentityCollectionCatagoryFilterData(collectionCategoryID) {
    const response = await CommonGet('/api/CollectionCategoryTypeMapping/FilterCollectionCategoryType', 'collectionCategoryID=' + collectionCategoryID);
    return response.data;
}

async function AddOperationentityCollectionCatagory(data, selectedOptions) {
    
    let collectionType = {
        collectionTypeID: 0,
        collectionCategoryID: parseInt(data.collectionCategoryID),
        CollectionTypes:  selectedOptions,
        productID: parseInt(data.productID),
        operationEntityID: parseInt(data.operationEntityID),
        isActive: data.isActive,
        isDefault: data.isDefault,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }

    var response = await CommonPost('/api/CollectionCategoryTypeMapping/AddOpearationentityCollectionCatagory', null, collectionType);
    return response;
}

async function EditOperationentityCollectionCatagory(collectionTypeID) {
    var response = await CommonPost('/api/CollectionCategoryTypeMapping/DisableCollectionType', 'collectionTypeID=' + collectionTypeID);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1] !== undefined && item[1]["operationEntityID"] === id && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getGroupByCollectionCatagoryID(collectionCatagoryID) {
    var response = await CommonGet('/api/OpearationentityCollectionCatagoryMapping/GetGroupByCollectionCatagory', 'ID=' + collectionCatagoryID);
    return response.data;
}

async function getAvialableProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}

async function getUnsusedProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetUnusedProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}

async function getCollectionCategoryByProductID(productID){
    var productsArray = [];
    var response = await CommonGet('/api/OpearationentityCollectionCatagoryMapping/GetCollectionCategoryByProductID','productID=' + productID.toString());
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["collectionCategoryMasterID"]] = item[1]["collectionCategoryName"];
    }
    return productsArray;
}

async function getProducts() {
    var products = [];
    var response = await CommonGet('/api/Product/GetProducts', null);
    for (let item of Object.entries(response.data)) {
            products[item[1]["productID"]] = item[1]["productName"];
    }
    return products;
}

async function getCollectionType(data) {
    var collectionTypeArray = [];
    var filterModel = {
        collectionCategoryID: parseInt(data.collectionCategoryID),
        productID: parseInt(data.productID),
        collectionTypeID: 0
    }
    var response = await CommonPost('/api/CollectionCategoryTypeMapping/GetCollectionCategoryByProductIDAndCollectionCategory', null, filterModel);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionTypeArray.push({ label: item[1]["collectionTypeName"], value: item[1]["collectionTypeMasterID"] });
    }
    return collectionTypeArray;
}

async function checkDefaultColletionTypeAvailability(collectionCategoryID) {
    
    var response = await CommonGet('/api/CollectionCategoryTypeMapping/CheckDefaultColletionTypeAvailability', 'collectionCategoryID=' + collectionCategoryID);
    
    return response;
}

async function getCollectionTypeForEditScreen(collectionCategoryID) {
    var collectionTypeArray = [];
    var response = await CommonGet('/api/CollectionCategoryTypeMapping/GetCollectionTypesForCollectionCategoryTypeMappingScreen', 'collectionCategoryID=' + collectionCategoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionTypeArray.push({ label: item[1]["collectionTypeName"], value: item[1]["collectionTypeMasterID"] });
    }
    return collectionTypeArray;
}